<template>
  <el-dialog
    v-if="visible"
    visible
    :title="title || defaultTitle"
    show-close
    width="1100px"
    :close-on-click-modal="false"
    :before-close="() => close()"
    append-to-body
    v-el-dialog-drag
  >
    <PageTable
      ref="table"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :multiple="multiple"
      @reload="reload"
      @choose-change="(r) => (checkedRows = r)"
    >
      <PageHeader
        slot="header"
        ref="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageTable>

    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-badge :value="checkedCount" class="ml-2" v-if="multiple">
        <el-button
          type="primary"
          size="small"
          @click="confirm()"
          :disabled="!checkedCount"
        >
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </el-badge>
      <el-button
        v-if="!multiple"
        type="primary"
        size="small"
        class="ml-2"
        @click="confirm()"
        :disabled="!checkedCount"
      >
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import PageHeader from './header.vue'
import PageTable from './table.vue'
import BaseTable from '@/mixins/base-table'
export default {
  components: { PageHeader, PageTable },
  mixins: [BaseTable],
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    extrasParams: { type: Object, default: () => ({}) },
    multiple: { type: Boolean, default: false },
    confirmOnClose: { type: Boolean, default: true },
  },
  data() {
    return { defaultTitle: '选择面料信息', checkedRows: null, usePage: true }
  },
  computed: {
    checkedCount() {
      if (this.multiple) {
        return !this.checkedRows ? 0 : this.checkedRows.length
      }
      return this.checkedRows ? 1 : 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .masterFabricChooseListApi({
          ...form,
          ...this.page,
          ...this.extrasParams,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    async confirm() {
      if (!this.checkedCount) return
      const validResult = await this.$refs.table.validEvent()
      console.log('validResult', validResult)
      if (!validResult) return
      this.$emit('confirm', this.checkedRows)
      if (this.confirmOnClose) this.close()
      this.checkedRows = null
    },
  },
}
</script>
